import { ExternalLink } from 'lucide-react';
import { Button } from '@/shared/ui/button';

export function ApiDocsPage() {
  return (
    <div className="space-y-4">
      {/* Page header */}
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-[#2b2b2b]">API Documentation</h1>
          <p className="text-[#807f7e]">Public REST API for gUBI frontend integration</p>
        </div>
        <a href="/api/docs" target="_blank" rel="noopener noreferrer">
          <Button variant="outline">
            <ExternalLink className="w-4 h-4 mr-2" />
            Open in new tab
          </Button>
        </a>
      </div>

      {/* Embedded Swagger UI */}
      <iframe
        src="/api/docs"
        className="w-full h-[calc(100vh-180px)] border border-[#e5e5e5] rounded-lg"
        title="API Documentation"
      />
    </div>
  );
}
